import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

// Applies admin-defined URL redirects client-side (WordPress-style) before the
// 404 page is shown. Exact pathname match (trailing slash + URL-encoding safe).
export default function RedirectGate() {
  const [rules, setRules] = useState([]);
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/redirects").then((r) => setRules(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!rules.length) return;
    const norm = (p) => {
      let x = p || "/";
      try { x = decodeURIComponent(x); } catch (_) {}
      x = x.replace(/\/+$/, "");
      return x === "" ? "/" : x;
    };
    const cur = norm(loc.pathname);
    const rule = rules.find((r) => norm(r.from) === cur || r.from === loc.pathname);
    if (rule && rule.to) {
      if (/^https?:\/\//i.test(rule.to)) {
        window.location.replace(rule.to);
      } else if (norm(rule.to) !== cur) {
        navigate(rule.to, { replace: true });
      }
    }
  }, [loc.pathname, rules, navigate]);

  return null;
}
